import React, { memo } from "react";
import { Stack, Typography, Card, CardContent, Box, Tooltip, Icon } from "investira.react.components";
import RegiaoMapChart from "./RegiaoMapChart";
const RegioesSection = memo(props => {
  const {
    title,
    data,
    map = "brasilMap"
  } = props;
  return <Stack spacing={2} sx={{
    height: "100%"
  }}>
      <Card sx={{
      height: "100%"
    }}>
        <CardContent sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        height: "100%"
      }}>
          <Stack alignItems="space-between" direction="row">
            <Stack flexGrow={1}>
              <Typography variant="subtitle1" color="textPrimary" sx={{
              fontWeight: 600
            }} component="h4">
                {title}
              </Typography>
            </Stack>
            <Stack alignItems="center" justifyContent="center">
              <Tooltip title={`${title} mais relevantes`}>
                <Box sx={{
                width: "16px",
                height: "16px"
              }}>
                  <Icon iconName="information" size={16} color="primary" />
                </Box>
              </Tooltip>
            </Stack>
          </Stack>

          <Stack sx={{
          flex: 1,
          minWidth: 0,
          height: "100%",
          justifyContent: "center",
          alignItems: "center"
        }}>
            <RegiaoMapChart data={data} title={{
            text: ""
          }} map={map} />
          </Stack>
        </CardContent>
      </Card>
    </Stack>;
});
export default RegioesSection;
